module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_sick_cell_info_scene.902880d3.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_sick_cell_info_scene.json
// module id = 2225
// module chunks = 0